import created from './attrs/created'
import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import Rating from 'vue-star-rating'

export default {
    name: 'ReplySatisfactionSurvey',
    created,
    computed,
    data,
    methods,
    mounted,
    components: {
        Rating
    }
}
